var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container offset-md-3 col-md-6 pt-5 pb-5" },
    [
      _c("h2", [_vm._v("パスワードリセット")]),
      _vm._v(" "),
      _c("toast", { ref: "toast" }),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.resetPassword($event)
            }
          }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "mail" } }, [
              _vm._v(
                "登録されたメールアドレス宛に新しいパスワードが送信されます"
              )
            ]),
            _vm._v(" "),
            _vm.invalid
              ? _c("p", { staticClass: "text-danger" }, [
                  _vm._v("無効なメールアドレスです")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mail,
                  expression: "mail"
                }
              ],
              staticClass: "form-control",
              class: { "border-danger": _vm.invalid },
              attrs: {
                type: "mail",
                id: "mail",
                placeholder: "メールアドレス",
                required: ""
              },
              domProps: { value: _vm.mail },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.mail = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("input", {
            staticClass: "btn btn-secondary",
            attrs: { type: "button", value: "戻る" },
            on: {
              click: function($event) {
                return _vm.$router.go(-1)
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "btn btn-primary",
            attrs: { type: "submit", value: "リセット" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59eab85c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59eab85c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/common/ResetPassword.vue
// module id = 353
// module chunks = 0